import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import Button from "../../../button/Button";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import UserfulConfirmationDialog from "../../../ConfirmationDialog/UserfulConfirmationDialog";

interface IProps {
    hide: () => void;
    confirm: () => void;
    pendingDestination;
}

const HLSAudioWarning = (props: IProps) => {
    const { t } = useTranslation();

    return (
        <>
            <UserfulConfirmationDialog
                show={!!props.pendingDestination}
                onCancel={props.hide}
                varient="warning"
                title={t("CommonUI.MappingGroups.hlsAudioWarning")}
                message={t("CommonUI.MappingGroups.hlsAudioWarningDesc")}
                replaceFooter={
                    <>
                        <Button variant="secondary" onClick={props.hide}>
                            {t("Shared.cancel")}
                        </Button>
                        <Button variant="primary" onClick={props.confirm}>
                            {t("Shared.confirm")}
                        </Button>
                    </>
                }
            />
        </>
    );
};

export default HLSAudioWarning;
